<div class="background-container" style="background-image: url('../assets/img/stars-bg.jpg');">
<div class="container">
  <div class="row" style="    background: rgba(30, 156, 240, .733);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;">
    <div class="col-xl-12 main-title d-flex align-items-center">
        <a href="" target="_blank" aria-label="Go to Mentality Solana">
            <img style="
                border: 2px solid gold;
                border-radius: 30px;" 
                src="../favicon.ico" 
                aria-hidden="true"
                height="50px"
                width="50px"
                 />
                
        </a>
        <h4 class="m-3" style="color: gold">Junkee Meme Maker</h4>
    </div>
      <div class="col-xl-12">
          <div class="row">
              <div class="col-xl-12 text-right">
                  <button data-toggle="tooltip" data-placement="bottom" title="Export to image" type="button" class="btn m-1" (click)="rasterize();">
                      <i class="fa fa-download" aria-hidden="true"></i> Export to image</button>
                  <button data-toggle="tooltip" data-placement="bottom" title="Export to SVG" type="button" class="btn m-1" (click)="rasterizeSVG();">
                      <i class="fa fa-download" aria-hidden="true"></i> Export to SVG</button>

                  <button style="color:red" data-toggle="tooltip" data-placement="bottom" title="Clean Canvas" type="button" class="btn" (click)="confirmClear();">
                      <i class="fa fa-ban" aria-hidden="true"></i> Reset</button>
              </div>
          </div>
      </div>
  </div>
  <hr>
  <div class="row">
      <div class="col-xl-3">
          <div class="card">
              <div class="card-header">Size</div>
              <div class="card-body">
                  <div class="form-group">
                      <div class="input-group">
                          <input type="text" class="form-control" [(ngModel)]="canvas.size.width" (keyup)="changeSize()">
                          <div class="input-group-append">
                              <span class="input-group-text">
                                  Width
                              </span>
                          </div>
                      </div>
                  </div>
                  <div class="form-group">
                      <div class="input-group mb-3">
                          <input type="text" class="form-control" [(ngModel)]="canvas.size.height" (keyup)="changeSize()">
                          <div class="input-group-append">
                              <span class="input-group-text">
                                  Height
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <br/>
          <div class="card">
            <div class="card-header">Free Drawing Mode</div>
            <div class="card-body">
                <div class="input-group">

                    <div class="input-group-append">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch1" (click)="drawMode()">
                        <label class="custom-control-label" for="customSwitch1">Enable / Disable</label>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <br _ngcontent-snb-c45="">
          <div class="card">
              <div class="card-header">Add text</div>
              <div class="card-body">
                  <div class="input-group">
                      <input type="text" class="form-control" [(ngModel)]="canvas.textString">
                      <div class="input-group-append">
                          <span class="input-group-text">
                              <button id="add-text" data-toggle="tooltip" data-placement="bottom" title="Add text" class="btn btn-primary" (click)="addText()">
                                  <i class="fa fa-plus" aria-hidden="true"></i>
                              </button>
                          </span>
                      </div>
                  </div>
              </div>
          </div>
          <br/>
          <div class="card">
              <div class="card-header">Add images</div>
              <div class="max-height">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/junkee-heatmap.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/eyes-1.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/eyes-2.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/eyes-3.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/mouth-1.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/mouth-2.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/mouth-3.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/lower-1.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/lower-2.png">
                  <img class="images-item" (click)="getImgPolaroid($event)" src="../assets/img/lower-3.png">
              </div>
          </div>
          <br/>
          <div class="card">
              <div class="card-header">Upload image</div>
              <div class="card-body text-center">
                  <img id="testImage" *ngIf="canvas.url" class="images-item-upload" [src]="canvas.url" (click)="addImageOnCanvas(canvas.url);">
                  <input type="file" (change)="readUrl($event);">
                  <br/>
                  <br/>
                  <div class="btn-group btn-group-justified" role="group" aria-label="...">
                      <div class="btn-group" role="group">
                          <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeWhite(canvas.url);">
                              <i class="fa fa-times" aria-hidden="true"></i> Remove</button>
                      </div>
                  </div>
              </div>
          </div>
          <br/>
      </div>
      <div class="col-xl-6">
          <angular-editor-fabric-js #canvas></angular-editor-fabric-js>
      </div>
      <div class="col-xl-3">
          <div class="card">
              <div class="card-header">Options</div>
              <div class="card-body text-center">
                  <div class="btn-group" role="group" aria-label="...">
                      <button data-toggle="tooltip" data-placement="bottom" title="Delete element" type="button" class="btn btn-outline-danger" 
                          (click)="removeSelected();">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                  </div>
              </div>
          </div>
          <br/>
          <div class="card" *ngIf="!canvas.selected">
              <div class="card-header">Canvas</div>
              <div class="card-body">
                  <div class="custom-item" *ngIf="!canvas.props.canvasImage">
                      <div class="custom-item-title">Background Color</div>
                      <div class="custom-item-body">
                          <input type="text" class="form-control" [cpPosition]="'bottom'" [(colorPicker)]="canvas.props.canvasFill" [style.background]="canvas.props.canvasFill"
                              [value]="canvas.props.canvasFill" (colorPickerChange)="setCanvasFill()">
                      </div>
                  </div>
                  <div class="custom-item">
                    <div class="custom-item-title">Text Color</div>
                    <div class="custom-item-body">
                      <input type="text" class="form-control"
                             [cpPosition]="'bottom'"
                             [(colorPicker)]="canvas.props.textColor" 
                             [style.background]="canvas.props.textColor"
                             [value]="canvas.props.textColor"
                             (colorPickerChange)="setTextColor()"> 
                    </div>
                  </div>
                  <div class="custom-item">
                      <div class="custom-item-title">Background Image (url)</div>
                      <div class="custom-item-body">
                          <input type="text" class="form-control" placeholder="http://example.jpg" [(ngModel)]="canvas.props.canvasImage" (keyup)="setCanvasImage()">
                      </div>
                  </div>

              </div>
          </div>
          <br/>
      </div>
  </div>
  <div class="row">
      <div class="col-xl-12">
          <br/>
      </div>
  </div>
  <br>
  <br>
</div>
</div>
